module.exports = __webpack_public_path__ + "05_short_gold.6e67b20e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/05_short_gold.png
// module id = isaN
// module chunks = 0